<template>
  <div>
    <b-card title="Bank Statement">
      <b-row class="mb-1">
        <!-- search input -->
        <b-col>
          <section>
            <b-button
              v-b-modal.modal-filterBankStatments
              variant="outline-primary"
              class="d-flex"
            >
              <feather-icon icon="FilterIcon" />Filter
            </b-button>
          </section>
        </b-col>
        <b-col>
          <section>
            <b-button
              v-b-modal.modal-filterRetrieveBSData
              variant="outline-primary"
              class="d-flex"
            >
              <feather-icon icon="FilterIcon" />Retrieve BS Data
            </b-button>
          </section>
        </b-col>
        <b-col>
          <b-form-group
            v-if="dataFiltered == true"
            class="d-flex justify-content-center"
          >
            <!-- search input -->
            <div>
              <b-form-input
                v-model="searchTerm"
                type="search"
                placeholder="search"
              />
            </div>
          </b-form-group>
        </b-col>

        <b-col v-if="dataFiltered === true" class="d-flex justify-content-end">
          <xlsx-workbook>
            <xlsx-sheet
              v-for="sheet in sheets"
              :key="sheet.name"
              :collection="sheet.data"
              :sheet-name="sheet.name"
            />
            <xlsx-download>
              <b-button variant="primary" class="d-flex">
                <feather-icon icon="DownloadCloudIcon" /> Export
              </b-button>
            </xlsx-download>
          </xlsx-workbook>
        </b-col>
      </b-row>
      <!-- table -->
      <vue-good-table
        :columns="columns"
        :rows="reconciliations"
        :rtl="direction"
        :search-options="{
          enabled: true,
          skipDiacritics: true,
          externalQuery: searchTerm,
        }"
        :pagination-options="{
          enabled: true,
          perPage: pageLength,
        }"
      >
        <template slot="pagination-bottom" slot-scope="props">
          <!-- pagination -->

          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
              <span class="text-nowrap"> Showing 1 to </span>
              <b-form-select
                v-model="pageLength"
                :options="['5', '10', '15', '30', '50']"
                class="mx-1"
                @input="
                  (value) => props.perPageChanged({ currentPerPage: value })
                "
              />
              <span class="text-nowrap"> of {{ props.total }} entries </span>
            </div>
            <div>
              <b-pagination
                :value="1"
                :total-rows="props.total"
                :per-page="pageLength"
                first-number
                last-number
                align="right"
                prev-class="prev-item"
                next-class="next-item"
                class="mt-1 mb-0"
                @input="(value) => props.pageChanged({ currentPage: value })"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </div>
          </div>
        </template>
      </vue-good-table>

      <b-row>
        <b-col>
          <b-modal
            id="modal-filterBankStatments"
            title="Filter Reconcilation"
            ok-title="Search"
            cancel-variant="outline-secondary"
            size="lg"
            @ok="filterBankStatments"
          >
            <b-form>
              <b-row>
                <b-col cols="4">
                  <b-form-group
                    label="Provider option"
                    label-for="provider-option"
                  >
                    <b-form-select
                      id="merchantId"
                      v-model="filterFopId"
                      :options="providers"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="4">
                  <b-form-group label="Category Type" label-for="category-type">
                    <b-form-select
                      id="merchantId"
                      v-model="accountGroup"
                      :options="accountGroupEnum"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group
                    label="Paid Date Range"
                    label-for="paid-date-range"
                  >
                    <flat-pickr
                      v-model="trxnDateRange"
                      class="form-control"
                      :config="{ mode: 'range', maxDate: 'today' }"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form>
          </b-modal>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-modal
            id="modal-filterRetrieveBSData"
            title="Retrieve BS Data"
            ok-title="Search"
            cancel-variant="outline-secondary"
            size="lg"
            @ok="filterRetrieveBSData"
          >
            <form ref="form" @submit.stop.prevent="filterRetrieveBSData">
              <b-row>
                <b-col cols="4">
                  <b-form-group
                    label="Provider option"
                    label-for="provider-option"
                    invalid-feedback="Provider option is required"
                    :state="referenceState"
                  >
                    <b-form-select
                      id="merchantId"
                      v-model="filterFopId"
                      :options="providers"
                      :state="referenceState"
                      required
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="4">
                  <b-form-group label="Category Type" label-for="category-type">
                    <b-form-select
                      id="merchantId"
                      v-model="accountGroup"
                      :options="accountGroupEnum"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group
                    label="Paid Date Range"
                    label-for="paid-date-range"
                  >
                    <flat-pickr
                      v-model="trxnDateRange"
                      class="form-control"
                      :config="{ mode: 'range', maxDate: 'today' }"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </form>
            <template #modal-footer="{ ok }">
              <b-button variant="primary" @click="ok()"> Submit Now </b-button>
            </template>
          </b-modal>
        </b-col>
      </b-row>

      <!-- loadings -->
      <b-overlay :show="isLoading" no-wrap rounded="sm" />
    </b-card>
  </div>
</template>

<script>
import {
  BTabs,
  BTab,
  BCard,
  BButton,
  BBadge,
  BPagination,
  BOverlay,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormDatepicker,
  BRow,
  BCol,
  BForm,
  BTable,
  BCardText,
  BFormCheckbox,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import axios from "@axios";
import store from "@/store";
import flatPickr from "vue-flatpickr-component";
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
import XlsxSheet from "../../../../node_modules/vue-xlsx/dist/components/XlsxSheet";
import XlsxDownload from "../../../../node_modules/vue-xlsx/dist/components/XlsxDownload";
import XlsxWorkbook from "../../../../node_modules/vue-xlsx/dist/components/XlsxWorkbook";
export default {
  components: {
    BTabs,
    BTab,
    BRow,
    BCol,
    BCard,
    VueGoodTable,
    BBadge,
    BButton,
    BOverlay,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormDatepicker,
    flatPickr,
    BForm,
    BTable,
    BCardText,
    BCardActions,
    BFormCheckbox,
    XlsxWorkbook,
    XlsxSheet,
    XlsxDownload,
  },
  data() {
    const nowDate = new Date();
    return {
      isLoading: false,
      dataFiltered: false,
      pageLength: 5,
      dir: false,
      rangeDate: null,
      extendedDate: `${nowDate.getUTCFullYear()}-${
        nowDate.getUTCMonth() + 1
      }-${nowDate.getUTCDate()}`,
      orderDateRange: "",
      trxnDateRange: "",
      transactionType: "",
      VendorTxnRefNumber: "",
      orderStartDate: "",
      trxnStartDate: "",
      orderEndDate: "",
      trxnEndDate: "",
      orderFirstName: "",
      orderLastName: "",
      orderEmail: "",
      orderPhone: "",
      orderAmount: "",
      orderCurrency: "",
      orderCity: "",
      orderCountry: "",
      orderChannel: "",
      selectedOrder: "",
      filterOrderId: "",
      filterFopId: 0,
      filterFirstName: "",
      filterLastName: "",
      filtertrnxDate: "",
      accountGroup: 0,
      bankName: "",
      transactionDate: "",
      valueDate: "",
      postingDate: "",
      transactionType: "",
      transactionReference: "",
      debit: "",
      credit: "",
      orderCode: "",
      payerAccount: "",
      payerName: "",
      columns: [
        {
          label: "Merchant Name",
          field: "merchantName",
        },
        {
          label: "Provider",
          field: "provider",
        },
        {
          label: "Credit Account Number",
          field: "creditAccountNumber",
        },
        {
          label: "Order Code",
          field: "orderCode",
        },
        {
          label: "Transaction Reference",
          field: "transactionRef",
        },
        {
          label: "Transaction Date",
          field: "transactionDateString",
        },
        {
          label: "Transaction Type",
          field: "transactionType",
        },
        {
          label: "Credit Amount",
          field: "creditAmount",
        },
        {
          label: "Currency",
          field: "currency",
        },
        {
          label: "Depositor Name",
          field: "depositorName",
        },
        {
          label: "Value Date",
          field: "valueDateString",
        },
        {
          label: "Posting Date",
          field: "postingDateString",
        },
        {
          label: "Debit Account Number",
          field: "debitAccountNumber",
        },
      ],
      accountGroupEnum: [
        { value: 1, text: "Revenue Ticket" },
        { value: 2, text: "E-Staff Ticket" },
        { value: 3, text: "Aviation University" },
        { value: 4, text: "Ethiopian Visa" },
        { value: 5, text: "Ethiopian Passport" },
        { value: 6, text: "Ethiopian OriginID" },
        { value: 7, text: "Ethiopian Cargo" },
      ],
      providers: [],
      selectedCurrency: "ETB",
      searchTerm: "",
      editabelData: {},
      orderHistory: [],
      orderRefundHistory: [],
      orderHistories: [
        "paymentStatusDescription",
        "transactionDate",
        "actionTakenBy",
      ],
      referenceNumber: "",
      referenceState: null,
      selectedOrderCode: "",
      titleApprove: "",
      amount: 0,
      refundRequest: {
        orderCode: "",
        amount: 0,
        currency: "ETB",
        accountNumber: "",
        isRefundToSeparateAccountNumber: false,
      },
      status: "monthly",
      monthlyPlanShow: true,
      pricing: {
        basicPlan: {
          title: "Basic",
          // eslint-disable-next-line global-require
          img: require("@/assets/images/illustration/Pot1.svg"),
          subtitle: "A simple start for everyone",
          monthlyPrice: 0,
          yearlyPlan: {
            perMonth: 0,
            totalAnual: 0,
          },
          planBenefits: [
            "100 responses a month",
            "Unlimited forms and surveys",
            "Unlimited fields",
            "Basic form creation tools",
            "Up to 2 subdomains",
          ],
          popular: false,
        },
        standardPlan: {
          title: "Standard",
          // eslint-disable-next-line global-require
          img: require("@/assets/images/illustration/Pot2.svg"),
          subtitle: "For small to medium businesses",
          monthlyPrice: 49,
          yearlyPlan: {
            perMonth: 40,
            totalAnual: 480,
          },
          planBenefits: [
            "Unlimited responses",
            "Unlimited forms and surveys",
            "Instagram profile page",
            "Google Docs integration",
            "Custom “Thank you” page",
          ],
          popular: true,
        },
        enterprisePlan: {
          title: "Enterprise",
          // eslint-disable-next-line global-require
          img: require("@/assets/images/illustration/Pot3.svg"),
          subtitle: "Solution for big organizations",
          monthlyPrice: 99,
          yearlyPlan: {
            perMonth: 80,
            totalAnual: 960,
          },
          planBenefits: [
            "PayPal payments",
            "Logic Jumps",
            "File upload with 5GB storage",
            "Custom domain support",
            "Stripe integration",
          ],
          popular: false,
        },
      },
      reconciliations: [],
      ordersId: [],
      sheets: [{ name: "Bank Statments", data: [] }],
    };
  },
  computed: {
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        1: "light-success",
        0: "light-danger",
        /* eslint-enable key-spacing */
      };

      return (status) => statusColor[status];
    },
  },
  created() {
    this.fetchallProvider();
  },
  methods: {
    fetchallProvider() {
      this.isLoading = true;
      this.$store.dispatch("config/getActionPrivilege", "Reconciliation-View");
      axios
        .get("/Provider/api/V1.0/Provider/GetAll")
        .then((res) => {
          res.providers.map((provider) => {
            this.providers.push({
              value: provider.id,
              text: provider.providerName,
            });
          });
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    filterBankStatments() {
      if (this.orderDateRange !== "") {
        const [orderSttDate, orderEdDate] = this.orderDateRange.split(" to ");

        if (this.orderDateRange.includes("to")) {
          this.orderStartDate = orderSttDate;
          this.orderEndDate = orderEdDate;
        } else {
          this.orderStartDate = this.orderDateRange;
          this.orderEndDate = this.orderDateRange;
        }
      }

      if (this.trxnDateRange !== "") {
        const [trxnSttDate, trxnEdDate] = this.trxnDateRange.split(" to ");
        // this.trxnEndDate = `${trxnEdDate.trim()}`
        // this.trxnStartDate = `${trxnSttDate.trim()}`

        if (this.trxnDateRange.includes("to")) {
          this.trxnStartDate = trxnSttDate;
          this.trxnEndDate = trxnEdDate;
        } else {
          this.trxnStartDate = this.trxnDateRange;
          this.trxnEndDate = this.trxnDateRange;
        }
      }
      const url = `/BankStatements/api/V1.0/BankStatements/GetMerchantBankStatements?accountGroup=${this.accountGroup}&transactionDateFrom=${this.trxnStartDate}&transactionDateTo=${this.trxnEndDate}&providerId=${this.filterFopId}`;
      // Api call
      this.isLoading = true;
      axios
        .get(url)
        .then((res) => {
          this.sheets[0].data = [];
          this.dataFiltered = true;
          this.reconciliations = res.bankStatements;
          res.bankStatements.map((m) => {
            this.sheets[0].data.push({
              "Merchant Name": m.merchantName,
              Provider: m.provider,
              "Credit Account Number": m.creditAccountNumber,
              "Order Code": m.orderCode,
              "Transaction Reference": m.transactionRef,
              "Transaction Date": m.transactionDateString,
              "Transaction Type": m.transactionType,
              "Credit Amount": m.creditAmount,
              Currency: m.currency,
              "Depositor Name": m.depositorName,
              "Value Date": m.valueDateString,
              "Posting Date": m.postingDateString,
              "Debit Account Number": m.debitAccountNumber,
            });
          });
          this.isLoading = false;
          this.trxnEndDate = "";
          this.trxnStartDate = "";
        })
        .catch((res) => {
          this.isLoading = false;
          this.reconciliations = [];

          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              icon: "BellIcon",
              variant: "danger",
              text: `${res.data.message}`,
            },
          });
          // this.$refs.loginForm.setErrors(error)
          this.orderStartDate = "";
          this.orderEndDate = "";
          this.trxnEndDate = "";
          this.trxnStartDate = "";
        });
    },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      this.referenceState = valid;
      return valid;
    },
    filterRetrieveBSData(bvModalEvt) {
      if (!this.checkFormValidity()) {
        bvModalEvt.preventDefault();
        return;
      }
      if (this.orderDateRange !== "") {
        const [orderSttDate, orderEdDate] = this.orderDateRange.split(" to ");

        if (this.orderDateRange.includes("to")) {
          this.orderStartDate = orderSttDate;
          this.orderEndDate = orderEdDate;
        } else {
          this.orderStartDate = this.orderDateRange;
          this.orderEndDate = this.orderDateRange;
        }
      }

      if (this.trxnDateRange !== "") {
        const [trxnSttDate, trxnEdDate] = this.trxnDateRange.split(" to ");
        // this.trxnEndDate = `${trxnEdDate.trim()}`
        // this.trxnStartDate = `${trxnSttDate.trim()}`

        if (this.trxnDateRange.includes("to")) {
          this.trxnStartDate = trxnSttDate;
          this.trxnEndDate = trxnEdDate;
        } else {
          this.trxnStartDate = this.trxnDateRange;
          this.trxnEndDate = this.trxnDateRange;
        }
      }
      const url = `/BankStatements/api/V1.0/BankStatements/ManualBankStatementRetrieval?AccountGroup=${this.accountGroup}&transactionDateFrom=${this.trxnStartDate}&transactionDateTo=${this.trxnEndDate}&ProviderId=${this.filterFopId}`;
      // Api call
      this.isLoading = true;
      axios
        .get(url)
        .then((res) => {
          this.$swal({
            icon: "success",
            title: res.message,
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
          this.isLoading = false;
          this.orderDateRange = "";
        })
        .catch((res) => {
          this.isLoading = false;
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              icon: "BellIcon",
              variant: "danger",
              text: `${res.data.message}`,
            },
          });
          // this.$refs.loginForm.setErrors(error)
          this.orderDateRange = "";
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

<style lang="scss">
@import "@core/scss/vue/pages/page-pricing.scss";
</style>
